import createLucideIcon from '../createLucideIcon';

const UserCog2 = createLucideIcon('UserCog2', [
  ['path', { d: 'M14 19a6 6 0 0 0-12 0', key: 'vej9p1' }],
  ['circle', { cx: '8', cy: '9', r: '4', key: '143rtg' }],
  ['circle', { cx: '19', cy: '11', r: '2', key: '1rxg02' }],
  ['path', { d: 'M19 8v1', key: '1iffrw' }],
  ['path', { d: 'M19 13v1', key: 'z4xc62' }],
  ['path', { d: 'm21.6 9.5-.87.5', key: '6lxupl' }],
  ['path', { d: 'm17.27 12-.87.5', key: '1rwhxx' }],
  ['path', { d: 'm21.6 12.5-.87-.5', key: 'agvc9a' }],
  ['path', { d: 'm17.27 10-.87-.5', key: '12d57s' }],
]);

export default UserCog2;
